import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from '../../theming';

/* Colors text */

const colorPrimary = app => ({
	color: app.theme.textDark,
});

const colorSecondary = app => ({
	color: app.theme.textLight,
});

const colors = (type, app) => ({
	color: app.theme[type],
});
/* Components */

export const Title = ({ title, subtitle, pipe = true }) => {
	const app = useContext(ThemeContext);
	const { body14, body25 } = app.theme.font;
	return (
		<>
			<Text className="text-center" size={body25} type='primary'>{`${title} ${pipe ? '/' : ''} `}</Text>
			<Text size={body14} type='primary' style={{ fontWeight: 'bolder'}}>
				{subtitle}
			</Text>
		</>
	);
};

Title.propTypes = {
	title: PropTypes.string,
	subtitle: PropTypes.string,
	pipe: PropTypes.bool,
};

/* Text */

export const TextGeneric = ({ children, semi_bold = false, bold = false, color = 'black', className = '', size = 0.8 }) => {
	const body = {
		fontSize: `${size}rem`,
		color: color,
		fontWeight: bold ? '700' : semi_bold ? 'normal' : ''
	};
	return (
		<span className={`${className}`} style={body}>
			{children}
		</span>
	);
};

export const Text = ({ children, type = 'secondary', bold = false, className = '', style = {}, size = 0.8 }) => {
	const app = useContext(ThemeContext);
	const primary = { ...colorPrimary(app), ...{ fontSize: `${size}rem` } };
	const secondary = { ...colorSecondary(app), ...{ fontSize: `${size}rem` } };
	const body = type === 'primary' ? primary : secondary;
	return (
		<span className={`${className} ${bold ? 'font-weight-bolder' : ''}`} style={{...body, ...style}}>
			{children}
		</span>
	);
};

export const TextButton = ({ children, type = 'secondary', bold = false, className = '', size = 0.8 , style = null}) => {
	const primary = { ...{ fontSize: `${size}rem` } };
	const secondary = { ...{ fontSize: `${size}rem` } };
	const body = type === 'primary' ? primary : secondary;
	return (
		<span className={`${className} ${bold ? 'font-weight-bolder' : ''}`} style={{...body, ...style}}>
			{children}
		</span>
	);
};

export const CustomTextWithoutPadding = ({ children, type = 'secondary', bold = false, className = '', size = 0.8, style }) => {
	const app = useContext(ThemeContext);
	const primary = { ...colorPrimary(app), ...{ fontSize: `${size}rem`, paddingLeft: '0px', lineHeight: 'normal' } };
	const secondary = { ...colorSecondary(app), ...{ fontSize: `${size}rem`, paddingLeft: '0px', lineHeight: 'normal' } };
	const body = type === 'primary' ? primary : secondary;
	return (
		<span className={`${className} ${bold ? 'font-weight-bolder' : ''}`} style={body}>
			{children}
		</span>
	);
};

Text.propTypes = {
	children: PropTypes.node,
	type: PropTypes.string,
	bold: PropTypes.bool,
	className: PropTypes.string,
	size: PropTypes.number,
};

/* Text Colored */
export const TextColored = ({ children, focusText=null, type = 'gray',style = {}, bold = false, className = '', size = 0.8 }) => {
	const app = useContext(ThemeContext);
	const body = { ...colors(type, app), ...{ fontSize: `${size}rem`, fontWeight: 400 } };
	return (
		<span ref={focusText} className={`${className} ${bold ? 'font-weight-bolder' : ''}`} style={{...body,...style}}>
			{children}
		</span>
	);
};

export const TextCustomColored = ({ children, color = 'gray', bold = false, className = '', size = 0.8, onClick = () => { } }) => {
	const body = { ...{ fontSize: `${size}rem`, color: color, fontWeight: 400 } };
	return (
		<span className={`${className} ${bold ? 'font-weight-bolder' : ''}`} style={body} onClick={onClick}>
			{children}
		</span>
	);
};

TextColored.propTypes = {
	children: PropTypes.node,
	type: PropTypes.string,
	bold: PropTypes.bool,
	className: PropTypes.string,
	size: PropTypes.number,
};
/* Link */
export const Link = ({ children, center = false, border = {}, type = 'textLight', size = 0.8, onClick = () => { } }) => {
	const app = useContext(ThemeContext);
	const body = {
		...colors(type, app),
		...{
			fontSize: `${size}rem`,
			alignSelf: center ? 'center' : '',
			...border
		}
	};
	return (
		<a href='#' onClick={onClick} style={body}>
			{children}
		</a>
	);
};

Link.propTypes = {
	text: PropTypes.node,
	onClick: PropTypes.func,
	size: PropTypes.number,
	type: PropTypes.string,
	border: PropTypes.object,
};

/* Pipe */
export const Pipe = ({ size = 20, center = false, color = 'black', marginLeft = '0px', marginRight = '0px', width = '100%' }) => {
	const app = useContext(ThemeContext);
	const pipe = {
		marginLeft: marginLeft,
		marginRight: marginRight,
		alignSelf: center ? 'center' : '',
		fontSize: `${size}px`,
		width: width,
		...colors(color, app),
	};
	return <span style={pipe}>|</span>;
};
